<template>
  <div class="columns is-mobile is-variable is-1">
    <div class="column">
      <a v-on:click="togglePlay" class="button is-fullwidth">
        <template v-if="isPlaying">
          <span class="icon">
            <i class="mdi mdi-18px mdi-pause"></i>
          </span>
          <span>Pause</span>
        </template>
        <template v-else>
          <span class="icon">
            <i class="mdi mdi-18px mdi-play"></i>
          </span>
          <span>Play</span>
        </template>
      </a>
    </div>
    <div class="column">
      <a v-on:click="shuffle" class="button is-fullwidth">
        <span class="icon">
          <i class="mdi mdi-18px mdi-shuffle"></i>
        </span>
        <span>Shuffle</span>
      </a>
    </div>
  </div>
</template>

<script>
  import { playerStatuses } from '@/constants'

  export default {
    name: 'AlbumControls',
    props: ['album', 'status'],
    computed: {
      isPlaying: function () {
        return this.status === playerStatuses.PLAYING
      },
      isPaused: function () {
        return this.status === playerStatuses.PAUSED
      },
      isStopped: function () {
        return this.status === playerStatuses.STOPPED
      },
    },
    methods: {
      togglePlay: function () {
        if (this.isStopped) {
          this.$store.commit('playTracks', { tracks: this.album.tracks })
        } else {
          this.$store.commit('togglePlay')
        }
      },
      shuffle: function () {
        this.$emit('shuffle')
      }
    }
  }
</script>
